import Decimal from 'decimal.js'
import { DiscountLevel, DiscountType, VoidCompReasonModel } from 'models'
import { DiscountContractWithCustom } from 'store/models/sellModels'
import { calculateDiscountAmount } from '../utils/orderCalculation/discountCalculation'

export const mockDiscountForComp = (
    comp: VoidCompReasonModel,
    isOrderLevel: boolean,
    totalLineForCalculateComp: Decimal,
    itemAmount: number = 1,
): DiscountContractWithCustom => {
    const value = new Decimal(comp.value ?? 0)
    const mockDiscount = {
        isCustomDiscount: true,
        level: isOrderLevel ? DiscountLevel.EntireOrder : DiscountLevel.Item,
        type: comp.isPercentage
            ? DiscountType.Percentage
            : DiscountType.FixedAmount,
        value: comp.value,
        name: comp.name ?? `COMP ${comp.isPercentage ? `${value}%` : ''}`,
    }
    // The comp discount price cannot be greater than the totalLinePrice.
    const compAmount = calculateDiscountAmount(
        mockDiscount,
        totalLineForCalculateComp,
        itemAmount,
    )

    return {
        ...mockDiscount,
        type: DiscountType.FixedAmount,
        value: compAmount.toNumber(),
    }
}
